<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 10L5 10" stroke="currentColor" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGMinusButton',
};
</script>

<style scoped lang="scss">

</style>
